document.querySelectorAll('.nt-faq-question').forEach(button => {
  button.addEventListener('click', () => {
    const faqItem = button.parentElement;
    const isOpen = faqItem.classList.contains('active');

    // Close all other items (Optional: remove this if you want multiple open)
    document.querySelectorAll('.nt-faq-item').forEach(item => {
      item.classList.remove('active');
      item.querySelector('.nt-faq-question').setAttribute('aria-expanded', 'false');
    });

    // Toggle current item
    if (!isOpen) {
      faqItem.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
    }
  });
});